import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, ViewChild, Output, EventEmitter } from "@angular/core";
import { ACTION_STATUS, ActionBarHandlerModel, ActionbarService } from "src/app/shared/ui/actionbar";
import { NewButtonModel, SaveButtonModel, CancelButtonModel, RefreshButtonModel } from "src/app/shared/ui/actionbar/models";
import { Observable, Subscription } from "rxjs";
import { NavigationService } from "src/app/shared/utils/navigation";
import { SecurityGroupService } from "src/app/core/services/system-services/security-group.service";
import { LoadingSpinnerService } from "src/app/shared/layout/loading-spinner";
import { SecurityGroupSecurityModel } from "src/app/core/models/security-model/security-group-security.model";
import { DxDataGridComponent } from "devextreme-angular";
import * as _ from 'lodash';
import { FormOfPaymentTypeSortService } from "./form-of-payment-type-sort.service";
import { FormOfPaymentTypeSort, FormOfPaymentTypeUpdateSortSequence } from "src/app/core/models/form-of-payment-model";
import { FormOfPaymentTypeSecurityCode } from "../payment-definition-categories";

@Component({
    selector: 'op-form-of-payment-type-sort',
    templateUrl: './form-of-payment-type-sort.component.html'
})
export class FormOfPaymentTypeSortComponent implements OnInit, OnDestroy, AfterViewInit {

    actionBarHandler = new ActionBarHandlerModel(
        new NewButtonModel(),
        new SaveButtonModel(),
        new CancelButtonModel(),
        new RefreshButtonModel(),
    )

    readonly ExportFileName = "Form of Payment"
    readonly PageSize = "A3";
    totalCount: number
    exportHeader: string[]
    exportData: any[]
    selectedRow: FormOfPaymentTypeSort

    focusing = false
    originDataSourceMap: Map<string, FormOfPaymentTypeSort>
    dataSource: FormOfPaymentTypeSort[]
    updateSortSequenceList: FormOfPaymentTypeUpdateSortSequence[]
    userSecurity: SecurityGroupSecurityModel
    userSecurity$: Observable<SecurityGroupSecurityModel>

    private subscriptions: Subscription[]

    @Output() onUpdateSortSequenceError = new EventEmitter<[string, string]>()
    @ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

    constructor(private formOfPaymentTypeSortService: FormOfPaymentTypeSortService,
        private navigateService: NavigationService,
        private securityGroupService: SecurityGroupService,
        private loadingSpinnerService: LoadingSpinnerService,
        private actionbarService: ActionbarService,
        private cdr: ChangeDetectorRef,) {
        this.onReorder = this.onReorder.bind(this)
    }
    ngOnInit(): void {
        this.originDataSourceMap = new Map()
        this.subscriptions = []
        this.subscriptions.push(
            this.formOfPaymentTypeSortService.callSort$.subscribe(() => {

            })
        )

        this.subscriptions.push(
            this.formOfPaymentTypeSortService.formOfPaymentTypes$.subscribe(formOfPaymentTypes => {
                formOfPaymentTypes.forEach(item =>
                    this.originDataSourceMap.set(item.formOfPaymentTypeCode, item))

                this.dataSource = _.cloneDeep(formOfPaymentTypes)
            })
        )

        this.subscriptions.push(
            this.formOfPaymentTypeSortService.refresh$
                .subscribe(() => {
                    this.refresh()
                })
        )

        this.subscriptions.push(
            this.formOfPaymentTypeSortService.updateSort$
                .subscribe(() => {
                    this.updateSortSequence()
                })
        )
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    ngAfterViewInit(): void {
        this.setupActionBar()
        this.refresh()

        this.subscriptions.push(
            this.securityGroupService.userSecurityGroupSecurity
                .subscribe(userSecurities => {
                    this.userSecurity = userSecurities.find(s => s.securityCode == FormOfPaymentTypeSecurityCode)
                    this.userSecurity$ = new Observable((observer) => observer.next(this.userSecurity))
                    if (this.userSecurity) {
                        this.actionBarHandler.get(ACTION_STATUS.new).enable(this.userSecurity.newFlag)
                        this.actionBarHandler.get(ACTION_STATUS.save).enable(this.userSecurity.editFlag)
                        this.actionbarService.updateState(this.actionBarHandler);
                    }
                })
        )
    }

    refresh() {
        this.loadingSpinnerService.show()
        this.subscriptions.push(
            this.formOfPaymentTypeSortService.getFormOfPaymentTypesSort()
                .subscribe(() => {
                    this.loadingSpinnerService.hide()
                    this.cdr.markForCheck()
                },
                    () => this.loadingSpinnerService.hide())
        )
    }

    updateSortSequence() {
        this.prepareSortSequenceListForUpdate()

        if (this.hasDuplicateSortSequence()) {
            this.onUpdateSortSequenceError.emit(['Sort Sequence', 'Sort Sequence is duplicate.'])
            return
        }

        if (!this.updateSortSequenceList.length)
            return

        this.loadingSpinnerService.showSaving()
        this.subscriptions.push(
            this.formOfPaymentTypeSortService.updateSortSequence(this.updateSortSequenceList).subscribe(() => {
                this.saveCompleteAndContinue(() => {
                    this.refresh()
                })
            }, () => this.loadingSpinnerService.hide())
        )
    }

    private saveCompleteAndContinue(action) {
        this.loadingSpinnerService.saveComplete()
        setTimeout(() => {
            action()
        }, 1000);
    }

    private setupActionBar() {
        this.actionBarHandler.get(ACTION_STATUS.new).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.save).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.cancel).enable(true);
        this.actionBarHandler.get(ACTION_STATUS.refresh).enable(true);
        this.actionbarService.updateState(this.actionBarHandler);
    }

    onContentReady(e): void {
        this.totalCount = e.component.totalCount()

        const filterExpr = this.dataGrid.instance.getCombinedFilter()
        const gridDataSource = this.dataGrid.instance.getDataSource()
        const filterDataSource = gridDataSource?.store().load({
            filter: filterExpr
        })

        const columns = this.dataGrid.instance.getVisibleColumns().filter(x => x.caption)
        const dataFields = Object.values(columns.map(item => item.dataField).filter(f => !!f))
        filterDataSource?.done((response: FormOfPaymentTypeSort[]) => {
            this.exportData = response.map(r => {
                let model = {}
                dataFields.map((v) => model[v] = r[v])
                return model
            })
        })
        this.exportHeader = columns.map(item => item.caption)
    }
    onRowClick(e): void {
        this.selectedRow = e.data
    }

    onCellPrepared(e): void {
        if (e.rowType === 'data') {
            if (e.column.dataField === 'sortSequence') {
                e.cellElement.addClass('dx-cell-editable')
            }
        }
    }

    onReorder(e): void {
        const visibleRows = e.component.getVisibleRows()
        const toIndex = this.dataSource.findIndex((item) => item.formOfPaymentTypeCode === visibleRows[e.toIndex].data.formOfPaymentTypeCode)
        const fromIndex = this.dataSource.findIndex((item) => item.formOfPaymentTypeCode === e.itemData.formOfPaymentTypeCode)

        this.dataSource.splice(fromIndex, 1)
        this.dataSource.splice(toIndex, 0, e.itemData)

        this.reOrderSortSequenceForAll()

        this.cdr.markForCheck()
    }

    private prepareSortSequenceListForUpdate(): void {
        this.updateSortSequenceList = this.dataSource.map(item => {
            if (this.originDataSourceMap.get(item.formOfPaymentTypeCode).sortSequence == item.sortSequence)
                return null

            return <FormOfPaymentTypeUpdateSortSequence>{
                formOfPaymentTypeCode: item.formOfPaymentTypeCode,
                sortSequence: item.sortSequence
            }
        })
            .filter(item => !!item)
    }

    private reOrderSortSequenceForAll(): void {
        let initialSortSequence = 1
        this.dataSource.forEach(dr => {
            dr.sortSequence = initialSortSequence
            initialSortSequence++
        })
    }

    private hasDuplicateSortSequence(): boolean {
        const originValues = this.dataSource.map(dr => dr.sortSequence?.toString())
        const uniqueValues = [...new Set(originValues)]

        return originValues.length != uniqueValues.length
    }

    updateSortSequenceValue(cell, e) {
        const currValue = e.target.value
        const target = this.dataSource.find(item => item.formOfPaymentTypeCode == cell.data.formOfPaymentTypeCode)
        if (currValue != null && (+currValue < 1 || +currValue > 99)) {
            target.sortSequence = null
        } else {
            target.sortSequence = currValue
        }
        this.dataGrid.instance.refresh()
    }
}
